import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"

import { humanize } from "src/utils/string_helpers"

const StatusBadge = ({ status }) => {
  if (!status) return null
  const displayText = humanize(status)
  return <Badge color={statusToken(displayText)} text={displayText} />
}

StatusBadge.propTypes = {
  status: PropTypes.string,
}

export default StatusBadge
